export default "<ion-app mode=\"ios\">\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";